import FirebaseAuthService from 'app/Core/services/FirebaseAuthService';
import XAPPService from 'app/Core/services/XAPPService';
import history from 'history.js';
export const REGISTER_WARNING = '[REGISTER APP] REGISTER WARNING';
export const REGISTER_INFO = '[REGISTER APP] REGISTER INFO';
export const REGISTER_ERROR = '[REGISTER APP] REGISTER ERROR';

export function createUserAuth(_AValue) {
    return (dispatch) => {
        _AValue.sistema = sessionStorage.getItem("sistema");
        _AValue.plano = sessionStorage.getItem("plano");
        _AValue.ctx = sessionStorage.getItem("ctx");
        _AValue.CriarTeste = sessionStorage.getItem('CriarTeste');
        _AValue.host = document.location.origin;
        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappCustomActionFactory("0", AActions, "", "ENVIARPRIMEIROACESSO", _AValue, "", AConditionsAND, AConditionsOR);

        XAPPService.XappRegisterAction(AActions, "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: REGISTER_WARNING,
                            payload: response.warning
                        })
                    ])
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: REGISTER_INFO,
                            payload: response.info
                        }),
                        history.push("/pub-confirmar-email?q=" + _AValue.email),
                        // document.location.reload()
                    ])
                }
            }

            ).catch(error => {
                FirebaseAuthService.Delete();
                return dispatch({
                    type: REGISTER_ERROR,
                    payload: error
                });
            });
    };
}


